import React from 'react';
import { Megaphone } from 'lucide-react';
import ChatGPTEntityTable from './ChatGPTEntityTable';

/**
 * Tableau des annonces ChatGPT Ads.
 *
 * Préréglage de `ChatGPTEntityTable` : mêmes mesures et même comportement que les groupes
 * d'annonces, un cran plus bas dans la hiérarchie du compte.
 *
 * ⚠️ **Ce que l'API ne dit pas, et que le tableau ne montre donc pas** : les insights au
 * niveau `ad` n'exposent ni le groupe ni la campagne parente. Il n'y a pas de colonne
 * « Campagne » ni « Groupe d'annonces » — ce n'est pas un oubli de mise en page. Le filtre
 * par campagne de l'en-tête, lui, descend la hiérarchie côté serveur pour savoir quelles
 * annonces retenir (voir `chargerAnnonces`).
 */
const ChatGPTAdsTable = ({ ads = [], previousAds = null, ...reste }) => (
  <ChatGPTEntityTable
    lignes={ads}
    lignesPrecedentes={previousAds}
    titre="Annonces"
    intituleColonne="Annonce"
    icone={Megaphone}
    classeSuffixe="ads"
    moduleId="chatgpt_ads"
    {...reste}
  />
);

export default ChatGPTAdsTable;
